import React from 'react';
import playerLoading from '@mediabank/assets/icons/player-loading.png';

import { usePlayerLoadingStyles } from './styles';

const PlayerLoading = () => {
    const { classes } = usePlayerLoadingStyles();

    return (
        <div className={classes.root} role="progressbar">
            <img alt="player loading" className={classes.image} src={playerLoading} />
        </div>
    );
};

export default PlayerLoading;
